import request from './request';

class Market {
  /**
   * 获取市场情绪周期率数据
   */
  getEmotioncycle() {
    return request.get(`//apigate.${window.Acme.getDomain()}/d/charge/hottrack/plate/emotioncycle`);
  }

  /**
   * 获取市场情绪周期热点类型
   */
  gethottype() {
    return request.get(`//apigate.${window.Acme.getDomain()}/d/charge/hottrack/plate/hottype`);
  }

  getFocus(type) {
    return request.get(`//apigate.${window.Acme.getDomain()}/d/charge/hottrack/plate/todayfocus`, { params: { type } });
  }

  //获取热点板块
  getCircleBlocks(params) {
    return request.get(`//apigate.${window.Acme.getDomain()}/d/charge/smallcharge/l2/v2/hotCirclePlate`, { params });
  }

  //市场风向标
  getBenchmark(params) {
    return request.get(`//apigate.${window.Acme.getDomain()}/d/charge/smallcharge/l2/hot/zqxy/benchmark`, { params });
  }
}

export default new Market();



// WEBPACK FOOTER //
// ./src/api/market.js